import ibanLib from 'iban';

export const validateIban = (accountNumber) => {
  const isValidIban = ibanLib.isValid(accountNumber);
  if (!isValidIban) return false;
  return true;
};
